module.exports = __webpack_public_path__ + "img/chart.91087574.png";